import { render, staticRenderFns } from "./EmailTemplatePanel.vue?vue&type=template&id=0a8e7d26&scoped=true"
import script from "./EmailTemplatePanel.vue?vue&type=script&lang=js"
export * from "./EmailTemplatePanel.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplatePanel.vue?vue&type=style&index=0&id=0a8e7d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8e7d26",
  null
  
)

export default component.exports